// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}
:host [tabindex] {
  outline: none;
}
:host ul {
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}
@media (max-width: 768px) {
  :host ul {
    position: absolute;
    bottom: 100%;
    width: 100%;
    display: none;
    z-index: 400;
  }
  :host ul.open {
    display: block;
  }
}
:host ul li {
  display: block;
  position: relative;
  color: #787D8B;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
:host ul li .button {
  text-align: center;
  text-transform: none;
}
:host ul li:first-of-type .button {
  border-radius: 2px 0 0 2px;
}
:host ul li:last-of-type .button {
  border-radius: 0 2px 2px 0;
}
:host ul li .label {
  position: absolute;
  left: 0;
  display: block;
  width: 100%;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 10px;
}
:host ul li.selected .button {
  background-color: #3E31FA;
  color: #FFF;
}
:host ul li.selected .button.icon ::ng-deep path {
  fill: #FFF !important;
}
:host ul li.selected .label {
  font-weight: 700;
  font-family: "RM Neue";
  color: #1A1E29;
}
:host ul li + li .button {
  border-left: 1px solid #E4E5E8;
}
:host ul li .toggle {
  position: absolute;
  bottom: -22px;
  left: calc(100% + 16px);
  z-index: 1;
}
:host ul li .toggle latitude-toggle ::ng-deep .wrapper {
  flex-direction: row-reverse;
}
:host ul li .toggle latitude-toggle ::ng-deep .label {
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #787D8B;
  margin-right: 5px;
}
:host ul li .toggle latitude-toggle ::ng-deep .toggle:after {
  background-color: #FFF;
}
:host ul li .toggle latitude-toggle ::ng-deep input:checked + .toggle {
  background-color: #3E31FA;
}
:host ul li .toggle latitude-toggle ::ng-deep input:checked ~ .label {
  color: #3E31FA;
}
:host ul li .button.icon {
  max-width: 48px;
}
@media (max-width: 768px) {
  :host ul li .button.icon {
    max-width: none;
  }
}
:host ul li.disabled .button {
  color: rgba(120, 125, 139, 0.25);
  cursor: default;
}
:host ul li.disabled .button .image {
  opacity: 0.25;
}
@media (max-width: 768px) {
  :host ul li .label, :host ul li .toggle {
    display: none;
  }
  :host ul li .button {
    border: none !important;
  }
}
:host ul.disabled li:not(.selected) .button {
  color: rgba(120, 125, 139, 0.25);
  cursor: default;
}
:host ul.disabled li:not(.selected) .button .image {
  opacity: 0.25;
}
:host .current {
  position: relative;
  display: none;
  color: #1A1E29;
}
@media (max-width: 768px) {
  :host .current {
    display: block;
  }
}
:host .current .label, :host .current .sublabel {
  position: absolute;
  left: 0;
  display: block;
  width: 100%;
  font-weight: 700;
  font-family: "RM Neue";
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
  margin-top: 10px;
}
:host .current .label {
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
:host .current .toggle {
  position: absolute;
  bottom: -22px;
  left: 100%;
  z-index: 1;
}
:host .current .toggle latitude-toggle ::ng-deep .wrapper {
  flex-direction: row-reverse;
}
:host .current .toggle latitude-toggle ::ng-deep .label {
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #787D8B;
  margin-right: 5px;
}
:host .current .toggle latitude-toggle ::ng-deep .toggle:after {
  background-color: #FFF;
}
:host .current .toggle latitude-toggle ::ng-deep input:checked + .toggle {
  background-color: #1A1E29;
}
:host .current .toggle latitude-toggle ::ng-deep input:checked ~ .label {
  color: #1A1E29;
}
:host .current .button {
  position: relative;
  padding-right: 40px;
}
:host .current .button:after {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  content: "";
  display: inline-block;
  height: 12px;
  width: 12px;
  background-image: url("/assets/img/icons/positive-dark/dropdown.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
:host .current .image ::ng-deep path {
  fill: #1A1E29;
}`, "",{"version":3,"sources":["webpack://./src/app/common/selector/selector.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAEA;EAIE,kBAAA;AAJF;AACE;EACE,aAAA;AACJ;AAEE;EACE,aAAA;EACA,oBAAA;EACA,wBAAA;AAAJ;AACI;EAJF;IAKI,kBAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,YAAA;EAEJ;EADI;IACE,cAAA;EAGN;AACF;AAAI;EACE,cAAA;EACA,kBAAA;EACA,cCbK;EA2ET,2BAAA;EACE,yBAAA;EAIQ,iBAAA;AD3DZ;AANM;EACE,kBAAA;EACA,oBAAA;AAQR;AALM;EACE,0BAAA;AAOR;AAJM;EACE,0BAAA;AAMR;AAHM;EACE,kBAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;ECeJ,gBAAA;EAUA,sBAAA;EDvBI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAMR;AADQ;EACE,yBCzDK;ED0DL,WCxCG;AD2Cb;AADU;EACE,qBAAA;AAGZ;AACQ;ECFJ,gBAAA;EAMA,sBAAA;EDFM,cC5DE;AD8DZ;AAGQ;EACE,8BAAA;AADV;AAKM;EACE,kBAAA;EACA,aAAA;EAEA,uBAAA;EACA,UAAA;AAJR;AAOU;EACE,2BAAA;AALZ;AAOU;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cCjFD;EDkFC,iBAAA;AALZ;AAQU;EACE,sBChFC;AD0Eb;AAUY;EACE,yBCvGC;AD+Ff;AAUY;EACE,cC1GC;ADkGf;AAcM;EACE,eAAA;AAZR;AAaQ;EAFF;IAGI,eAAA;EAVR;AACF;AAcQ;EACE,gCAAA;EACA,eAAA;AAZV;AAcU;EACE,aAAA;AAZZ;AAiBM;EACE;IACE,aAAA;EAfR;EAiBM;IACE,uBAAA;EAfR;AACF;AAsBU;EACE,gCAAA;EACA,eAAA;AApBZ;AAsBY;EACE,aAAA;AApBd;AA2BE;EACE,kBAAA;EACA,aAAA;EACA,cCvJQ;AD8HZ;AA0BI;EAJF;IAKI,cAAA;EAvBJ;AACF;AAwBI;EACE,kBAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;ECvGF,gBAAA;EAMA,sBAAA;EDmGE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AArBN;AAuBI;ECjHA,gBAAA;EAQA,+DAAA;ADsFJ;AAsBI;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AApBN;AAuBQ;EACE,2BAAA;AArBV;AAuBQ;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cCtLC;EDuLD,iBAAA;AArBV;AAwBQ;EACE,sBCrLG;AD+Jb;AA0BU;EACE,yBCrMA;AD6KZ;AA0BU;EACE,cCxMA;ADgLZ;AA6BI;EACE,kBAAA;EACA,mBAAA;AA3BN;AA4BM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EC/IN,WAAA;EACA,qBAAA;EACA,YD8I8E;EC7I9E,WD6IoF;EC5IpF,qEAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;ADsHF;AAuBM;EACE,aC1NI;ADqMZ","sourcesContent":["@import 'theme';\n\n:host {\n  [tabindex] {\n    outline: none;\n  }\n  position: relative;\n  ul {\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n    @media (max-width: $mobileBreakpoint) {\n      position: absolute;\n      bottom: 100%;\n      width: 100%;\n      display: none;\n      z-index: 400;\n      &.open {\n        display: block;\n      }\n    }\n\n    li {\n      display: block;\n      position: relative;\n      color: $colorN50;\n      @include noselect();\n      .button {\n        text-align: center;\n        text-transform: none;\n      }\n\n      &:first-of-type .button {\n        border-radius: 2px 0 0 2px;\n      }\n\n      &:last-of-type .button {\n        border-radius: 0 2px 2px 0;\n      }\n\n      .label {\n        position: absolute;\n        left: 0;\n        display: block;\n        width: 100%;\n        @include font(normal, condensed);\n        font-size: 10px;\n        line-height: 12px;\n        text-align: center;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n        margin-top: 10px;\n      }\n\n      &.selected {\n\n        .button {\n          background-color: $colorPrimary;\n          color: $colorWhite;\n\n          &.icon ::ng-deep path {\n            fill: $colorWhite !important;\n          }\n        }\n\n        .label {\n          @include font(bold, condensed);\n          color: $colorN100;\n        }\n      }\n\n      & + li {\n        .button {\n          border-left: 1px solid $colorN10;\n        }\n      }\n\n      .toggle {\n        position: absolute;\n        bottom: -22px;\n        // FIXME: refactor toggle position to avoid custom positions\n        left: calc(100% + 16px);\n        z-index: 1;\n\n        latitude-toggle ::ng-deep {\n          .wrapper {\n            flex-direction: row-reverse;\n          }\n          .label {\n            font-size: 10px;\n            line-height: 12px;\n            text-transform: uppercase;\n            letter-spacing: 1px;\n            color: $colorN50;\n            margin-right: 5px;\n          }\n\n          .toggle:after {\n            background-color: $colorWhite;\n          }\n\n          input:checked {\n            & + .toggle {\n              background-color: $colorPrimary;\n            }\n            & ~ .label {\n              color: $colorPrimary;\n            }\n          }\n        }\n      }\n\n      .button.icon {\n        max-width: 48px;\n        @media (max-width: $mobileBreakpoint) {\n          max-width: none;\n        }\n      }\n\n      &.disabled {\n        .button {\n          color: transparentize($colorN50, .75);\n          cursor: default;\n\n          .image {\n            opacity: .25;\n          }\n        }\n      }\n\n      @media (max-width: $mobileBreakpoint) {\n        .label, .toggle {\n          display: none;\n        }\n        .button {\n          border: none !important;\n        }\n      }\n    }\n\n    &.disabled {\n      li {\n        &:not(.selected) {\n          .button {\n            color: transparentize($colorN50, .75);\n            cursor: default;\n\n            .image {\n              opacity: .25;\n            }\n          }\n        }\n      }\n    }\n  }\n  .current {\n    position: relative;\n    display: none;\n    color: $colorN100;\n    @media (max-width: $mobileBreakpoint) {\n      display: block;\n    }\n    .label, .sublabel {\n      position: absolute;\n      left: 0;\n      display: block;\n      width: 100%;\n      @include font(bold, condensed);\n      font-size: 10px;\n      line-height: 12px;\n      text-align: center;\n      text-transform: uppercase;\n      letter-spacing: 1px;\n      white-space: nowrap;\n      margin-top: 10px;\n    }\n    .label {\n      @include font(bold);\n    }\n    .toggle {\n      position: absolute;\n      bottom: -22px;\n      left: 100%;\n      z-index: 1;\n\n      latitude-toggle ::ng-deep {\n        .wrapper {\n          flex-direction: row-reverse;\n        }\n        .label {\n          font-size: 10px;\n          line-height: 12px;\n          text-transform: uppercase;\n          letter-spacing: 1px;\n          color: $colorN50;\n          margin-right: 5px;\n        }\n\n        .toggle:after {\n          background-color: $colorWhite;\n        }\n\n        input:checked {\n          & + .toggle {\n            background-color: $colorN100;\n          }\n          & ~ .label {\n            color: $colorN100;\n          }\n        }\n      }\n    }\n    .button {\n      position: relative;\n      padding-right: 40px;\n      &:after {\n        position: absolute;\n        right: 14px;\n        top: 50%;\n        transform: translateY(-50%);\n        @include pseudoElemIcon('/assets/img/icons/positive-dark/dropdown.svg', 12px, 12px);\n      }\n    }\n    .image ::ng-deep {\n      path {\n        fill: $colorN100;\n      }\n    }\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
